import type { CSSProperties } from 'react'

interface LogoProps {
  size?: number
  showText?: boolean
  tone?: 'light' | 'dark'
  className?: string
  style?: CSSProperties
}

// Logo PharmaConnect — croix médicale stylisée dans un cercle teal + wordmark.
// La croix utilise la couleur du fond pour créer un effet "stamp" lisible.
export function Logo({
  size = 40,
  showText = true,
  tone = 'dark',
  className,
  style,
}: LogoProps) {
  const textColor = tone === 'dark' ? '#FFFFFF' : '#06110F'
  const mark = (
    <svg width={size} height={size} viewBox="0 0 40 40" aria-label="PharmaConnect">
      <rect width="40" height="40" rx="10" fill="#2D8F87" />
      <path
        d="M20 10v20M10 20h20"
        stroke={tone === 'dark' ? '#06110F' : '#FFFFFF'}
        strokeWidth="4"
        strokeLinecap="round"
      />
    </svg>
  )

  if (!showText) return mark

  return (
    <div
      className={className}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 12,
        ...style,
      }}
    >
      {mark}
      <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1 }}>
        <span
          style={{
            fontSize: size * 0.55,
            fontWeight: 800,
            letterSpacing: -0.5,
            color: textColor,
          }}
        >
          PharmaConnect
        </span>
        <span
          style={{
            fontSize: size * 0.28,
            fontWeight: 500,
            color: tone === 'dark' ? '#A1A1AA' : '#71717A',
            marginTop: 2,
          }}
        >
          Cameroun
        </span>
      </div>
    </div>
  )
}
